// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display: block; height: 0; overflow: hidden;}`, "",{"version":3,"sources":["webpack://./../shared/ng/components/dialog/container/container.component.ts"],"names":[],"mappings":"AAAA,MAAM,cAAc,EAAE,SAAS,EAAE,gBAAgB,CAAC","sourcesContent":[":host{display: block; height: 0; overflow: hidden;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
